import { request as sonataRequest } from 'sonata-react-components';

import type { DictionarySourcesQueryFieldsResponse } from 'geodata-api-model/lib/src/types/common.types';

type QueryFieldsResponse = DictionarySourcesQueryFieldsResponse & {
  optionsDictionary: Record<string, Record<number, string>>;
};

export function getSourceQueryFields(
  sourceId: string,
  queryFieldsNames?: string[],
  token: Record<string, any> = {}
): Promise<QueryFieldsResponse[]> {
  return sonataRequest.makeRequest(`${taptap.config.backendUrlBase}sources/${sourceId}/queryFields`, {
    method: 'GET',
    ...(queryFieldsNames && {
      params: {
        queryFieldsNames: queryFieldsNames.join(',')
      }
    }),
    token
  });
}
